var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkedin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 1.5C10.2304 1.5 1.5 10.2304 1.5 21C1.5 31.7696 10.2304 40.5 21 40.5C31.7696 40.5 40.5 31.7696 40.5 21C40.5 10.2304 31.7696 1.5 21 1.5ZM0.5 21C0.5 9.67816 9.67816 0.5 21 0.5C32.3218 0.5 41.5 9.67816 41.5 21C41.5 32.3218 32.3218 41.5 21 41.5C9.67816 41.5 0.5 32.3218 0.5 21Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5538 16.8285H15.5351C14.6038 16.8285 14 16.2053 14 15.4154C14 14.6101 14.6217 14 15.5716 14C16.5208 14 17.1044 14.6086 17.123 15.4131C17.123 16.203 16.5208 16.8285 15.5538 16.8285ZM27.2 26H24.2826V21.7815C24.2826 20.6773 23.8263 19.9235 22.8228 19.9235C22.0552 19.9235 21.6283 20.4322 21.4297 20.9225C21.3641 21.0774 21.3652 21.2859 21.3665 21.5009C21.3666 21.5301 21.3668 21.5594 21.3668 21.5887V26H18.4766C18.4766 26 18.5138 18.5274 18.4766 17.8481H21.3668V19.1275C21.5375 18.5681 22.4611 17.7697 23.9349 17.7697C25.7634 17.7697 27.2 18.9423 27.2 21.4672V26ZM16.9057 17.8481H14.3329V26H16.9057V17.8481Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/linkedin.109ae9bdafe8a1e252f8a2c6141aa3fd.svg";